export const FETCH_COACHBATCH_REQUEST = 'FETCH_COACHBATCH_REQUEST';
export const FETCH_COACHBATCH_SUCCESS = 'FETCH_COACHBATCH_SUCCESS';
export const FETCH_COACHBATCH_FAILURE = 'FETCH_COACHBATCH_FAILURE';
